import { ChevronRight, Database } from "lucide-react";
import { Link } from "react-router-dom";

export function DatasetBreadcrumbNav({
  clientId,
  clientLabel,
  datasetId,
  datasetLabel,
  currentLabel,
}: {
  clientId: string;
  clientLabel: string;
  datasetId: string;
  datasetLabel: string;
  currentLabel?: string;
}) {
  const clientPath = `/clients/${encodeURIComponent(clientId)}`;
  const datasetPath = `${clientPath}/datasets/${encodeURIComponent(datasetId)}`;
  return <nav className="dd-top-nav" aria-label="Navigation principale dataset">
    <div className="dd-top-nav-inner">
      <div className="dd-logo-section">
        <div className="dd-logo-badge" aria-hidden="true"><Database /></div>
        <Link to="/" className="dd-logo-link">
          <span>Lainvision</span>
          <span className="dd-particle-logo" aria-hidden="true" />
        </Link>
        <div className="dd-breadcrumb" aria-label="Fil d’Ariane">
          <Link to="/clients" className="dd-breadcrumb-link">Clients</Link>
          <ChevronRight className="dd-breadcrumb-chevron" aria-hidden="true" />
          <Link to={clientPath} className="dd-breadcrumb-link">{clientLabel}</Link>
          <ChevronRight className="dd-breadcrumb-chevron" aria-hidden="true" />
          {currentLabel ? <>
            <Link to={datasetPath} className="dd-breadcrumb-link">{datasetLabel}</Link>
            <ChevronRight className="dd-breadcrumb-chevron" aria-hidden="true" />
            <span className="dd-breadcrumb-current">{currentLabel}</span>
          </> : <span className="dd-breadcrumb-current">{datasetLabel}</span>}
        </div>
      </div>
    </div>
  </nav>;
}
